// extracted by mini-css-extract-plugin
export default {"headerBar":"NewIntegratedRoundForm_headerBar__j3-hj","visibleSwitch":"NewIntegratedRoundForm_visibleSwitch__RXglu"};